import React from "react"
import {Helmet} from "react-helmet"
import {ConfirmModal} from "components/shared/modals"
import useSiteMetadata from "hooks/useSiteMetadata"
import Toast from "components/shared/Toast"

/**
 * @type {React.FC<{children: React.ReactNode}>}
 */
const RootPageElement = ({children}) => {
  const {title} = useSiteMetadata()
  return (
    <>
      <Helmet title={title ?? "Giant ID"} />
      <ConfirmModal />
      <Toast />
      {children}
    </>
  )
}

export default RootPageElement
